var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHungarikum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.284,
    height: 38.275,
    viewBox: "0 0 41.284 38.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-143.768 -97.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M143.768,145.52c.5.009.945.033,1.387.023a10.536,10.536,0,0,0,4.264-1.107,22.731,22.731,0,0,0,4.461-2.865c.94-.745,1.791-1.6,2.715-2.369a13.813,13.813,0,0,1,6.718-3.379,8.36,8.36,0,0,1,4.714.623c.259.115.514.24.77.36l-.023.11c-.115.029-.228.062-.344.085a9.947,9.947,0,0,0-3.795,1.693,15.371,15.371,0,0,0-3.541,3.485c-.832,1.14-1.589,2.335-2.385,3.5-.828,1.212-1.638,2.437-2.505,3.62a4.8,4.8,0,0,1-2.837,1.819,6.414,6.414,0,0,1-4.107-.334,9.7,9.7,0,0,1-3.023-2,15.646,15.646,0,0,1-2.4-3.05A1.209,1.209,0,0,1,143.768,145.52Z",
    transform: "translate(0 -31.406)",
    fill: "#d9a45c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M260.276,162.206c.327.462.685.9.973,1.388a8.523,8.523,0,0,1,1.229,4.041,11.784,11.784,0,0,1-.6,4.165,26.461,26.461,0,0,1-2.129,4.586,22.485,22.485,0,0,0-2.686,7.1,9.84,9.84,0,0,0,.249,4.729c.032.1.046.2.1.427-.548-.191-1-.34-1.452-.507a11.373,11.373,0,0,1-2.745-1.517,9.3,9.3,0,0,1-2.317-2.455,6.324,6.324,0,0,1-1.043-3.935,5.91,5.91,0,0,1,1.7-3.691c1.131-1.221,2.285-2.42,3.419-3.638.676-.726,1.373-1.438,1.993-2.211a13.629,13.629,0,0,0,2.949-5.727,21.406,21.406,0,0,0,.232-2.5c.005-.065,0-.13,0-.195Z",
    transform: "translate(-86.713 -53.058)",
    fill: "#d9a45c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M324.755,193.514c.312.379.577.759.9,1.079a15.289,15.289,0,0,0,1.669,1.508c.914.669,1.888,1.256,2.834,1.881.508.335,1.029.652,1.512,1.02a1.922,1.922,0,0,1,.547,2.924,4.08,4.08,0,0,1-3.533,2.032,4.587,4.587,0,0,1-3.426-1.551,3.727,3.727,0,0,1-.818-2.1,20.978,20.978,0,0,1,.095-4.751c.049-.607.118-1.213.18-1.819C324.722,193.667,324.739,193.6,324.755,193.514Z",
    transform: "translate(-147.616 -78.653)",
    fill: "#d9a45c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M198.246,103.2c-.557.19-1.113.387-1.672.57a24.59,24.59,0,0,1-3.9,1.078,5.07,5.07,0,0,1-2.541-.106,3.756,3.756,0,0,1-1.518-1.145,4.09,4.09,0,0,1-1.042-2.625,3.35,3.35,0,0,1,.584-2.072,11.021,11.021,0,0,1,.746-.937,1.613,1.613,0,0,1,1.778-.579,2.931,2.931,0,0,1,1.029.577c.812.719,1.584,1.485,2.37,2.234.371.354.725.728,1.112,1.064a8.8,8.8,0,0,0,3.046,1.855Z",
    transform: "translate(-35.813)",
    fill: "#d9a45c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M250.232,103.216c-.358-.04-.716-.075-1.073-.12a15.007,15.007,0,0,1-2.435-.416,3.1,3.1,0,0,1-1.377-.719,2.294,2.294,0,0,1-.542-1.028,2.5,2.5,0,0,1,.106-1.722,2.047,2.047,0,0,1,.861-.994,6.747,6.747,0,0,1,.656-.324.986.986,0,0,1,1.133.142,1.791,1.791,0,0,1,.419.587c.262.609.49,1.233.73,1.851.113.292.212.591.339.877a5.374,5.374,0,0,0,1.2,1.817Z",
    transform: "translate(-82.514 -0.388)",
    fill: "#d9a45c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M323.417,165.034c.119.34.234.681.358,1.019a15.007,15.007,0,0,0,.954,2.278,3.1,3.1,0,0,0,1.011,1.18,2.3,2.3,0,0,0,1.123.3,2.5,2.5,0,0,0,1.654-.491,2.046,2.046,0,0,0,.775-1.063,6.718,6.718,0,0,0,.168-.712.986.986,0,0,0-.393-1.072,1.79,1.79,0,0,0-.666-.276c-.652-.118-1.311-.2-1.968-.294-.31-.045-.623-.074-.931-.132A5.371,5.371,0,0,1,323.46,165Z",
    transform: "translate(-146.866 -55.345)",
    fill: "#d9a45c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M291.225,127.448c-.165-.237-.335-.45-.472-.683a8.792,8.792,0,0,0-3.681-3.326c-.037-.019-.074-.039-.113-.056-.622-.267-.655-.318-.225-.829a5.838,5.838,0,0,1,2.376-1.932,2.286,2.286,0,0,1,2.382.471,6.968,6.968,0,0,1,1.228,1.409,2.75,2.75,0,0,1,.144,2.686,7.672,7.672,0,0,1-1.431,2.1A1.406,1.406,0,0,1,291.225,127.448Z",
    transform: "translate(-116.642 -18.936)",
    fill: "#d9a45c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M207.994,235.854c.607-.763,2.522-1.9,3.286-1.293s.087,2.729-.52,3.493a1.767,1.767,0,0,1-2.765-2.2Z",
    transform: "translate(-52.192 -112.069)",
    fill: "#d9a45c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHungarikum);
export default __webpack_public_path__ + "static/media/logo_hungarikum.a2a9170dc584ffe843d4a3c8c42876fa.svg";
export { ForwardRef as ReactComponent };